import axios from "axios"; //Limitless

import ClientContext from "../../../common/utils/client-context/ClientContext";
import { log as logger } from "../../../common/utils/Logging";
import { createPublicAPIRequest } from "../../../common/utils/PublicAPIUtils";
import { handleAPIFailure } from "../../../common/utils/api-log-helper/APILogHelper";
export var fetchCustomerHistory = function fetchCustomerHistory(customerEmailHash, callback) {
  var log = logger.getLogger("HistoryActions fetchHistoryMessage");
  var path = "history/".concat(customerEmailHash);
  var queryParams = {
    readonly: true,
    requester: "customer",
    tenantName: ClientContext._tenantName,
    groupName: ClientContext._groupName,
    filters: {
      archived: false
    },
    customerKey: ClientContext._customerKey
  };
  var apiConfig = createPublicAPIRequest("get", path, queryParams);
  axios(apiConfig).then(function (res) {
    log.debug(res.data);
    callback(res.data);
  }).catch(function (error) {
    handleAPIFailure(error, "CustomerMessageHistoryAPI fetchHistoryMessage");
    callback({
      hasError: true
    });
  });
};